import script from "./TokenPrices.vue?vue&type=script&lang=ts&setup=true"
export * from "./TokenPrices.vue?vue&type=script&lang=ts&setup=true"

import "./TokenPrices.vue?vue&type=style&index=0&id=7fe067de&lang=css"

const __exports__ = script;

export default __exports__